/**
 * `jobs` — file de travaux sur MongoDB (base plateforme, 4.1 ; D9).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const TYPES_TRAVAIL = [
    'publication_site',
    'rendu_document',
    'rappel_echeance',
    'export_complet',
    'export_contact',
    'sauvegarde',
    'restauration_test',
    'purge_resiliation',
    'variantes_image',
    'expiration_reservations',
];
export const typeTravailSchema = z.enum(TYPES_TRAVAIL);
export const ETATS_TRAVAIL = ['en_attente', 'en_cours', 'termine', 'echoue'];
export const etatTravailSchema = z.enum(ETATS_TRAVAIL);
export const jobSchema = withAudit(z.object({
    _id: idSchema,
    type: typeTravailSchema,
    galerieId: idSchema.optional(),
    charge: z.record(z.string(), z.unknown()).default({}),
    etat: etatTravailSchema.default('en_attente'),
    tentatives: z.int().min(0).default(0),
    prochaineTentativeLe: z.date().optional(),
    termineLe: z.date().optional(),
    erreur: z.string().optional(),
}));
export const jobCreationSchema = jobSchema.omit({
    ...CHAMPS_DOCUMENT,
    etat: true,
    tentatives: true,
    termineLe: true,
    erreur: true,
});
//# sourceMappingURL=jobs.js.map